import type { ReactNode } from 'react';
import React from 'react';
import { Hideable } from '@prisjakt/ui/hideable';
import { Axis } from '@prisjakt/ui';
import * as S from './styles';

interface Props {
  children: ReactNode;
  expanded: boolean;
  title: string;
  onToggle: () => void;
  /** Provides an area for a badge showing some meta information about the group. */
  badge?: ReactNode;
  dark?: boolean;
}

export const ExpandableGroup = ({
  children,
  expanded,
  title,
  onToggle,
  badge,
  dark,
}: Props) => (
  <S.ExpandableGroup>
    <S.Header expanded={expanded} onClick={onToggle} dark={dark}>
      <ExpandedIndicator expanded={expanded} />
      <S.Title>{title}</S.Title>
      {badge && <S.BadgeArea>{badge}</S.BadgeArea>}
    </S.Header>
    <Hideable visible={expanded} collapse={Axis.Y}>
      {children}
    </Hideable>
  </S.ExpandableGroup>
);

interface IndicatorProps {
  expanded: boolean;
}

export const ExpandedIndicator = ({ expanded }: IndicatorProps) => (
  <S.HeaderArrow expanded={expanded} />
);
